import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./app.css";
import { InteractionHost } from "./interaction";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <InteractionHost />
  </StrictMode>
);
